module.exports = __webpack_public_path__ + "static/media/ks_background_sm.4ff99034.jpg";